export const SDPDS_ACCOUNT_MAP={
  aws: {
    prod: {
      'af-south-1': '746350833234',
      'ap-east-1': '461336235585',
      'ap-east-2': '590184135064',
      'ap-northeast-1': '111005587149',
      'ap-northeast-2': '877919990051',
      'ap-northeast-3': '704988065752',
      'ap-south-1': '952813526343',
      'ap-south-2': '638463395753',
      'ap-southeast-1': '426122873823',
      'ap-southeast-2': '995252913060',
      'ap-southeast-3': '975842593010',
      'ap-southeast-4': '008525728449',
      'ap-southeast-5': '432176808990',
      'ap-southeast-7': '533267113238',
      'ca-central-1': '987926072028',
      'ca-west-1': '021585708422',
      'eu-central-1': '554322765249',
      'eu-central-2': '092718257216',
      'eu-north-1': '450562347682',
      'eu-south-1': '727540170503',
      'eu-south-2': '347896288408',
      'eu-west-1': '187378840327',
      'eu-west-2': '014055627826',
      'eu-west-3': '024519467464',
      'il-central-1': '545386393929',
      'me-central-1': '970990200267',
      'me-south-1': '226114581152',
      'mx-central-1': '381492071935',
      'sa-east-1': '851079620173',
      'us-east-1': '165208870747',
      'us-east-2': '755582497987',
      'us-northeast-1': '443011789293',
      'us-west-1': '415776281654',
      'us-west-2': '697637932814'
    },
    beta: { // staging
      'af-south-1': '165641458533',
      'ap-east-1': '967059343998',
      'ap-northeast-1': '003048802255',
      'ap-northeast-2': '277671434785',
      'ap-northeast-3': '950720472832',
      'ap-south-1': '897640787139',
      'ap-south-2': '166470777772',
      'ap-southeast-1': '124786496057',
      'ap-southeast-2': '901774559536',
      'ap-southeast-3': '591638472454',
      'ap-southeast-4': '309916383178',
      'ap-southeast-5': '707034567664',
      'ap-southeast-7': '992382528588',
      'ca-central-1': '063351554485',
      'ca-west-1': '812061441411',
      'eu-central-1': '187594623133',
      'eu-central-2': '085125583093',
      'eu-north-1': '948267114716',
      'eu-south-1': '629712020169',
      'eu-south-2': '576060906539',
      'eu-west-1': '540955202671',
      'eu-west-2': '087505853659',
      'eu-west-3': '671352464277',
      'il-central-1': '771952131963',
      'me-central-1': '013048182588',
      'me-south-1': '771003022013',
      'mx-central-1': '851725402079',
      'sa-east-1': '124136440834',
      'us-east-1': '130292594404',
      'us-east-2': '058377332197',
      'us-northeast-1': '018174679735',
      'us-west-1': '198918249093',
      'us-west-2': '220372342558'
    },
    gamma: { // integ
      'us-west-2': '026141236302',
      'eu-south-1': '579050598674',
      'us-east-1': '537205933324'
    }
  },
} as { [key: string]: any };